/**
 * iso код страны в формате [List of ISO 3166 country codes](https://en.wikipedia.org/wiki/List_of_ISO_3166_country_codes)
 **/
export const COUNTRY_CODE = {
  RU: 'RU',
  AM: 'AM',
  BY: 'BY',
  GE: 'GE',
  KG: 'KG',
  KZ: 'KZ',
  MD: 'MD',
  TJ: 'TJ',
  UZ: 'UZ',
  other: 'other',
} as const
